import { initializeApp } from "firebase/app"
import { getMessaging } from "firebase/messaging"

const firebaseConfig = {
  apiKey: "AIzaSyDBI3Ze1dU2P7QWE6CUVn9GbxPQpy9MTJM",
  authDomain: "kredtapapp.firebaseapp.com",
  projectId: "kredtapapp",
  storageBucket: "kredtapapp.firebasestorage.app",
  messagingSenderId: "623984574585",
  appId: "1:623984574585:web:82226f6836652aefa954a8",
  measurementId: "G-Y7BM2P4FX1"
};


const app = initializeApp(firebaseConfig)
export const messaging = getMessaging(app)